import {
  getUiPermissionsMap,
  getMyGrantedComponents,
} from "./api/uiPermissions";
import { getTokenPayload, extractRoles } from "./auth";

let permissionsVersion = 0;
let componentRolesMap = {}; // key -> [roles]
let grantedSet = null; // Set<string> for /me optimization
let cachedRoles = [];

export async function loadPermissions({ preferServerEvaluation = true } = {}) {
  const payload = getTokenPayload();
  cachedRoles = extractRoles(payload).map((r) => r.toUpperCase());
  if (preferServerEvaluation) {
    try {
      const data = await getMyGrantedComponents();
      const list = Array.isArray(data?.granted) ? data.granted : [];

      permissionsVersion = data?.version || 0;
      grantedSet = new Set(list.map((k) => String(k).toUpperCase()));
      componentRolesMap = {}; // not needed when grantedSet is present
      return;
    } catch (err) {
      console.error("Failed to load server grants", err);
    }
  }

  // Fallback to client-side evaluation using map
  const map = await getUiPermissionsMap();

  componentRolesMap = normalizeKeys(map || {});

  grantedSet = null;
}

export function canAccess(componentKey) {
  const key = String(componentKey || "").toUpperCase();

  if (grantedSet) {
    const hasAccess = grantedSet.has(key);
    return hasAccess;
  }
  const allowedRoles = componentRolesMap[key];
  // console.log(allowedRoles);

  if (!allowedRoles) return false;
  const allowedSet = new Set(allowedRoles.map((r) => r.toUpperCase()));
  return cachedRoles.some((r) => allowedSet.has(r));
}

export function useCanAccess(componentKey) {
  // Hook facade kept simple to avoid adding state; suitable for immediate gating.
  return canAccess(componentKey);
}

function normalizeKeys(obj) {
  console.log(obj);

  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    out[String(k).toUpperCase()] = Array.isArray(v) ? v : [];
  }
  return out;
}
